import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Stock} from './stock';

@Injectable()
export class StockService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all stocks which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.stockURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(stock : Stock) {
    console.log('Push stock to insert method of service.');
    stock.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stock));
    return this.http.post(this.config.stockURL+"new", JSON.stringify(stock), {headers: this.headers});
  }

  public update(stock : Stock) {
    console.log('Push stock to update method of service.');
    stock.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stock));
    return this.http.put(this.config.stockURL+"id/"+stock.id, JSON.stringify(stock), {headers: this.headers});
  }

  public qryStock(id : number) {
    return this.http.post(this.config.stockURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete stock '+ id);
    return this.http.post(this.config.stockURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock.service.ts